import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const quickLinks = [
  { to: '/', label: '首页' },
  { to: '/analysis/an001', label: '数据分析' },
  { to: '/search', label: '搜索' },
  { to: '/about', label: '关于我们' },
  { to: '/contact', label: '联系我们' },
];

const socials = [
  { icon: 'ri-message-3-line', label: '公众号' },
  { icon: 'ri-links-line', label: '分享站点' },
  { icon: 'ri-qr-code-line', label: '扫码关注' },
  { icon: 'ri-mail-line', label: '邮件订阅' },
];

export default function Footer() {
  return (
    <footer className="mt-12 md:mt-16 bg-primary-900 text-primary-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 font-heading font-bold flex items-center justify-center text-sm">
                51
              </span>
              <span className="font-heading font-semibold text-background-50 text-lg tracking-wide">
                51每日大赛
              </span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200 max-w-xs">
              今日大赛聚集地，聚合最新赛事资讯、往期黑5数据统计与深度分析，帮助体育爱好者全面了解赛事动态。
            </p>
            <div className="flex items-center gap-2 mt-5">
              {socials.map((item) => (
                <span
                  key={item.label}
                  title={item.label}
                  className="w-9 h-9 rounded-md bg-primary-800 text-primary-100 flex items-center justify-center hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={`${item.icon} w-4 h-4 flex items-center justify-center`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-background-50 text-sm font-semibold tracking-wide mb-4">
              赛事分类
            </h3>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-primary-200 hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-background-50 text-sm font-semibold tracking-wide mb-4">
              快速导航
            </h3>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-200 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-background-50 text-sm font-semibold tracking-wide mb-4">
              热门专题
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/analysis/an001" className="text-sm text-primary-200 hover:text-accent-400 transition-colors">
                  足球黑5指数月度全景
                </Link>
              </li>
              <li>
                <Link to="/analysis/an002" className="text-sm text-primary-200 hover:text-accent-400 transition-colors">
                  篮球黑5专项分析
                </Link>
              </li>
              <li>
                <Link to="/analysis/an003" className="text-sm text-primary-200 hover:text-accent-400 transition-colors">
                  电竞黑5指数复盘
                </Link>
              </li>
              <li>
                <Link to="/analysis/an004" className="text-sm text-primary-200 hover:text-accent-400 transition-colors">
                  往期黑5数据年度回顾
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-primary-300">
            © 2026 51每日大赛 · 今日大赛聚集地　保留所有权利
          </p>
          <p className="text-xs text-primary-300">
            本站数据均为前端演示示例，不构成任何投注建议
          </p>
        </div>
      </div>
    </footer>
  );
}